import { css } from 'lit';

export default css`:root{--fs-pagination-height:52px}:host{--fs-pagination-height:52px;display:inline-block}:host(:focus){box-shadow:none !important}`;